import CONSTANTS from '@/helpers/constants';
import { getDepartmentById } from '@/utils/getDepartments';
import { IFacilityInfo } from '~/api/IFacilityInfo';

// Hybrid (RNDB) sends the department as a plain string on the facility. A value of
// '<#>' (DEFAULT_STRING), null, '' or undefined all mean "no department".
export const isMeaningfulDepartment = (department?: string | null): boolean => (
  !!department && department !== CONSTANTS.DATA_VALUES.DEFAULT_STRING
);

// Resolves the department name to display for a facility.
// - Hybrid: read the `department` string sent by the backend.
// - Standalone/Portal: read the first entry of `facilityDepartments` and map its
//   type id to a display name.
export const getFacilityDepartmentName = (
  facility: Partial<IFacilityInfo> | undefined | null,
  isHybrid: boolean,
): string | null => {
  if (!facility) return null;

  if (isHybrid) {
    return isMeaningfulDepartment(facility.department) ? (facility.department as string) : null;
  }

  const departments = facility.facilityDepartments;
  if (!departments?.length) return null;
  return getDepartmentById(departments[0].departmentTypeId)?.value || null;
};
